import { Skeleton } from 'shared/ui/skeleton'

import s from './styles.module.scss'

export const PriceStepSkeleton = () => (
  <div className={s.card}>
    <Skeleton
      className={s.title}
      borderRadius={6}
    />
    <Skeleton className={s.field} />
  </div>
)
